import { toast } from 'react-toastify';
import { t } from 'i18n';

const toastOptions = {
  position: 'top-left',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const genericToast = (msg, messageType) => {
  if (!msg) return;
  toast.clearWaitingQueue();

  toast[messageType](msg, toastOptions);
};

export const notifyError = (msg) => {
  const message = msg ?? t('notifyManager.genericError');
  genericToast(message, 'error');
};
export const notifySuccess = (msg) => genericToast(msg ?? t('notifyManager.success'), 'success');
export const notifyWarn = (msg) => genericToast(msg ?? t('notifyManager.warn'), 'warn');

export default { notifyError, notifySuccess, notifyWarn };
